import { Routes, Route, useLocation } from 'react-router-dom';

import MainPage from './Pages/MainPage';
import MemberPage from './Pages/MemberPage';
import NoticePage from './Pages/NoticePage';
import EventPage from './Pages/EventPage';
import IconPage from './Pages/IconPage';
import QuotePage from './Pages/QuotePage';
import QuoteInfoPage from './Pages/QuoteInfoPage';
import RequoteInfoPage from './Pages/RequoteInfoPage';
import LoginPage from './Pages/LoginPage';
import ApplyPage from './Pages/ApplyPage';
import ApplyInfoPage from './Pages/ApplyInfoPage';
import MemberInfoPage from './Pages/MemberInfoPage';
import ResetPasswordPage from './Pages/ResetPasswordPage';
import CommentsPage from './Pages/CommentsPage';
import { useEffect } from 'react';

export default function Router() {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname !== '/login' && sessionStorage.getItem('login') !== 'true') {
            window.location.href = '/login';
        }
    }, [ location ]);

    return (
        <div>
            <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/users" element={<MemberPage />} />
                <Route path="/users/:id" element={<MemberInfoPage />} />
                <Route path="/notice" element={<NoticePage />} />
                <Route path="/event" element={<EventPage />} />
                <Route path="/icon" element={<IconPage />} />
                <Route path="/quote" element={<QuotePage />} />
                <Route path="/quote/:id" element={<QuoteInfoPage />} />
                <Route path="/requote/:requoteId" element={<RequoteInfoPage />} />
                <Route path="/apply" element={<ApplyPage />} />
                <Route path="/apply/:id" element={<ApplyInfoPage />} />
                <Route path="/resetPassword" element={<ResetPasswordPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/comments" element={<CommentsPage />} />
            </Routes>
        </div>
    );
}